export enum SchemaName {
  Admin = 'admin',
  Builder = 'builder_',
  Subbie = 'subbie',
  ItpSubbie = 'itp_subbie',
  Leads = 'leads',
  SupplierInsights = 'supplier_insights',
  SalesAndBilling = 'sales_and_billing',
}
